import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* mallLoadVoucherList() {
  yield takeEvery(actionTypes.MALL_LOAD_VOUCHER_LIST, function*(action) {
    try {
      const response = yield API.loadVoucherList(action.data, null, null);
      if (response.data.success) {
        yield put(actions.mallVoucherListSuccess(response.data));
      } else {
        alert(
          "Warning: Fail to load mall voucher list. \n" + response.data.message
        );
        // yield put(actions.mallLoadShopDetailsFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to load mall voucher list. \n")
      );
      //   yield put(actions.mallLoadShopDetailsFail());
    }
  });
}

export default function* mallVoucherSaga() {
  yield all([fork(mallLoadVoucherList)]);
}
